/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompleteOperationDetailUploadRequest,
  CompleteOperationNoticeUpload200Response,
  CompleteOperationNoticeUploadRequest,
  GetOperationDetail200Response,
  GetOperationNotice200Response,
  ListOperations200Response,
  ListOperations200ResponseItemsInner,
  ListOperations400Response,
} from '../models/index';
import {
    CompleteOperationDetailUploadRequestFromJSON,
    CompleteOperationDetailUploadRequestToJSON,
    CompleteOperationNoticeUpload200ResponseFromJSON,
    CompleteOperationNoticeUpload200ResponseToJSON,
    CompleteOperationNoticeUploadRequestFromJSON,
    CompleteOperationNoticeUploadRequestToJSON,
    GetOperationDetail200ResponseFromJSON,
    GetOperationDetail200ResponseToJSON,
    GetOperationNotice200ResponseFromJSON,
    GetOperationNotice200ResponseToJSON,
    ListOperations200ResponseFromJSON,
    ListOperations200ResponseToJSON,
    ListOperations200ResponseItemsInnerFromJSON,
    ListOperations200ResponseItemsInnerToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
} from '../models/index';

export interface CompleteOperationDetailUploadOperationRequest {
    operationId: string;
    completeOperationDetailUploadRequest: CompleteOperationDetailUploadRequest;
}

export interface CompleteOperationNoticeUploadOperationRequest {
    operationId: string;
    completeOperationNoticeUploadRequest: CompleteOperationNoticeUploadRequest;
}

export interface DownloadOperationDetailZipRequest {
    operationId: string;
}

export interface DownloadOperationNoticeZipRequest {
    operationId: string;
}

export interface DownloadOperationReportCsvRequest {
    operationId: string;
}

export interface DownloadOperationSummaryCsvRequest {
    operationId: string;
}

export interface GetOperationRequest {
    operationId: string;
}

export interface GetOperationDetailRequest {
    operationId: string;
}

export interface GetOperationNoticeRequest {
    operationId: string;
}

export interface ListOperationsRequest {
    page?: number;
    count?: number;
    approvalStatus?: ListOperationsApprovalStatusEnum;
    processStatus?: ListOperationsProcessStatusEnum;
    serviceName?: string;
    settlementDateFrom?: Date;
    settlementDateTo?: Date;
}

export interface UploadOperationDetailZipRequest {
    operationId: string;
    file: Blob;
}

export interface UploadOperationNoticeZipRequest {
    operationId: string;
    file: Blob;
}

/**
 * 
 */
export class OperationsApi extends runtime.BaseAPI {

    /**
     * 明細データのアップロード完了を通知し、operationIdを返却する。
     * 明細データアップロード完了
     */
    async completeOperationDetailUploadRaw(requestParameters: CompleteOperationDetailUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteOperationNoticeUpload200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling completeOperationDetailUpload().'
            );
        }

        if (requestParameters['completeOperationDetailUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'completeOperationDetailUploadRequest',
                'Required parameter "completeOperationDetailUploadRequest" was null or undefined when calling completeOperationDetailUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/detail/complete`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteOperationDetailUploadRequestToJSON(requestParameters['completeOperationDetailUploadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteOperationNoticeUpload200ResponseFromJSON(jsonValue));
    }

    /**
     * 明細データのアップロード完了を通知し、operationIdを返却する。
     * 明細データアップロード完了
     */
    async completeOperationDetailUpload(requestParameters: CompleteOperationDetailUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteOperationNoticeUpload200Response> {
        const response = await this.completeOperationDetailUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払通知書のアップロード完了を通知し、operationIdを返却する。
     * 支払通知書アップロード完了
     */
    async completeOperationNoticeUploadRaw(requestParameters: CompleteOperationNoticeUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteOperationNoticeUpload200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling completeOperationNoticeUpload().'
            );
        }

        if (requestParameters['completeOperationNoticeUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'completeOperationNoticeUploadRequest',
                'Required parameter "completeOperationNoticeUploadRequest" was null or undefined when calling completeOperationNoticeUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/notice/complete`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteOperationNoticeUploadRequestToJSON(requestParameters['completeOperationNoticeUploadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteOperationNoticeUpload200ResponseFromJSON(jsonValue));
    }

    /**
     * 支払通知書のアップロード完了を通知し、operationIdを返却する。
     * 支払通知書アップロード完了
     */
    async completeOperationNoticeUpload(requestParameters: CompleteOperationNoticeUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteOperationNoticeUpload200Response> {
        const response = await this.completeOperationNoticeUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 明細データZipダウンロード
     */
    async downloadOperationDetailZipRaw(requestParameters: DownloadOperationDetailZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling downloadOperationDetailZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/detail/download`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 明細データZipダウンロード
     */
    async downloadOperationDetailZip(requestParameters: DownloadOperationDetailZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadOperationDetailZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払通知書Zipダウンロード
     */
    async downloadOperationNoticeZipRaw(requestParameters: DownloadOperationNoticeZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling downloadOperationNoticeZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/notice/download`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 支払通知書Zipダウンロード
     */
    async downloadOperationNoticeZip(requestParameters: DownloadOperationNoticeZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadOperationNoticeZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * payment_group_id→company_id の昇順で並び替えた集計CSVを返す。 列構成は仕様（p.21–22）の「集計期間始まり, 集計期間終わり, 締め年月, 精算処理日, company_id, company_name, payment_group_id, PG名, 支払通知書会社名, インボイス番号, 納品番号, service_id, 費目, 課税区分, 会社ごとの支払額, 入金先銀行名/支店名/支店番号/口座区分/口座番号/口座名義, PDF用の名前」等に準拠。 
     * 経理用集計CSVダウンロード
     */
    async downloadOperationReportCsvRaw(requestParameters: DownloadOperationReportCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling downloadOperationReportCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/report/download`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * payment_group_id→company_id の昇順で並び替えた集計CSVを返す。 列構成は仕様（p.21–22）の「集計期間始まり, 集計期間終わり, 締め年月, 精算処理日, company_id, company_name, payment_group_id, PG名, 支払通知書会社名, インボイス番号, 納品番号, service_id, 費目, 課税区分, 会社ごとの支払額, 入金先銀行名/支店名/支店番号/口座区分/口座番号/口座名義, PDF用の名前」等に準拠。 
     * 経理用集計CSVダウンロード
     */
    async downloadOperationReportCsv(requestParameters: DownloadOperationReportCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadOperationReportCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * バッチ処理結果の注文番号単位の一覧を CSV で返す。
     * 注文明細一覧CSVダウンロード
     */
    async downloadOperationSummaryCsvRaw(requestParameters: DownloadOperationSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling downloadOperationSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/summary/download`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * バッチ処理結果の注文番号単位の一覧を CSV で返す。
     * 注文明細一覧CSVダウンロード
     */
    async downloadOperationSummaryCsv(requestParameters: DownloadOperationSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadOperationSummaryCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払業務の詳細
     */
    async getOperationRaw(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOperations200ResponseItemsInner>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling getOperation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOperations200ResponseItemsInnerFromJSON(jsonValue));
    }

    /**
     * 支払業務の詳細
     */
    async getOperation(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOperations200ResponseItemsInner> {
        const response = await this.getOperationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アップロード済み明細データの取得
     */
    async getOperationDetailRaw(requestParameters: GetOperationDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOperationDetail200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling getOperationDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/detail`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOperationDetail200ResponseFromJSON(jsonValue));
    }

    /**
     * アップロード済み明細データの取得
     */
    async getOperationDetail(requestParameters: GetOperationDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOperationDetail200Response> {
        const response = await this.getOperationDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アップロード済み支払通知書の取得
     */
    async getOperationNoticeRaw(requestParameters: GetOperationNoticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOperationNotice200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling getOperationNotice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations/{operation_id}/notice`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOperationNotice200ResponseFromJSON(jsonValue));
    }

    /**
     * アップロード済み支払通知書の取得
     */
    async getOperationNotice(requestParameters: GetOperationNoticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOperationNotice200Response> {
        const response = await this.getOperationNoticeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払業務一覧
     */
    async listOperationsRaw(requestParameters: ListOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOperations200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['approvalStatus'] != null) {
            queryParameters['approval_status'] = requestParameters['approvalStatus'];
        }

        if (requestParameters['processStatus'] != null) {
            queryParameters['process_status'] = requestParameters['processStatus'];
        }

        if (requestParameters['serviceName'] != null) {
            queryParameters['service_name'] = requestParameters['serviceName'];
        }

        if (requestParameters['settlementDateFrom'] != null) {
            queryParameters['settlement_date_from'] = (requestParameters['settlementDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['settlementDateTo'] != null) {
            queryParameters['settlement_date_to'] = (requestParameters['settlementDateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOperations200ResponseFromJSON(jsonValue));
    }

    /**
     * 支払業務一覧
     */
    async listOperations(requestParameters: ListOperationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOperations200Response> {
        const response = await this.listOperationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 明細データ（xlsx/pdf/csv）を含むZipファイルを受け取り、S3等に保存。 ファイル命名規則: {PG名}_{納品番号}_{費目ID}_{明細データなどのタイトル}.pdf, .xlsx, .csv 費目ID: CANCELREFUND1（キャンセル料・不課税）, TIP（チップ） 明細データは一つの支払業務に対して複数回アップ可能(同一名称は上書き、別名称は追加アップ) 
     * 明細データZipアップロード
     */
    async uploadOperationDetailZipRaw(requestParameters: UploadOperationDetailZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOperationDetail200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling uploadOperationDetailZip().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadOperationDetailZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/operations/{operation_id}/detail`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOperationDetail200ResponseFromJSON(jsonValue));
    }

    /**
     * 明細データ（xlsx/pdf/csv）を含むZipファイルを受け取り、S3等に保存。 ファイル命名規則: {PG名}_{納品番号}_{費目ID}_{明細データなどのタイトル}.pdf, .xlsx, .csv 費目ID: CANCELREFUND1（キャンセル料・不課税）, TIP（チップ） 明細データは一つの支払業務に対して複数回アップ可能(同一名称は上書き、別名称は追加アップ) 
     * 明細データZipアップロード
     */
    async uploadOperationDetailZip(requestParameters: UploadOperationDetailZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOperationDetail200Response> {
        const response = await this.uploadOperationDetailZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * MFで生成された支払通知書PDFのZipを受け取り、S3等に保存。 戻り値として含有ファイル名配列・アップロード総額・成功件数を返す。 併せてファイル命名（`{PG名}_{納品番号}_{payment_group毎の支払金額}_支払通知書.pdf`）に基づく検算を行う。 
     * 支払通知書Zipアップロード
     */
    async uploadOperationNoticeZipRaw(requestParameters: UploadOperationNoticeZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOperationNotice200Response>> {
        if (requestParameters['operationId'] == null) {
            throw new runtime.RequiredError(
                'operationId',
                'Required parameter "operationId" was null or undefined when calling uploadOperationNoticeZip().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadOperationNoticeZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/operations/{operation_id}/notice`;
        urlPath = urlPath.replace(`{${"operation_id"}}`, encodeURIComponent(String(requestParameters['operationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOperationNotice200ResponseFromJSON(jsonValue));
    }

    /**
     * MFで生成された支払通知書PDFのZipを受け取り、S3等に保存。 戻り値として含有ファイル名配列・アップロード総額・成功件数を返す。 併せてファイル命名（`{PG名}_{納品番号}_{payment_group毎の支払金額}_支払通知書.pdf`）に基づく検算を行う。 
     * 支払通知書Zipアップロード
     */
    async uploadOperationNoticeZip(requestParameters: UploadOperationNoticeZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOperationNotice200Response> {
        const response = await this.uploadOperationNoticeZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListOperationsApprovalStatusEnum = {
    PENDING: 0,
    APPROVED: 1
} as const;
export type ListOperationsApprovalStatusEnum = typeof ListOperationsApprovalStatusEnum[keyof typeof ListOperationsApprovalStatusEnum];
/**
 * @export
 */
export const ListOperationsProcessStatusEnum = {
    COMPLETED_AGGREGATED: 0,
    FAILED: 1,
    COMPLETED_PUBLISHED: 2,
    COMPLETED_DETAIL_PUBLISHED: 3,
    RUNNING: 4
} as const;
export type ListOperationsProcessStatusEnum = typeof ListOperationsProcessStatusEnum[keyof typeof ListOperationsProcessStatusEnum];
